import { CardContent, Grid, Stack, Card } from '@mui/material'
import bg1 from 'assets/pictures/background/bg1.jpg'
import bg2 from 'assets/pictures/background/bg2.jpeg'
import bg3 from 'assets/pictures/background/bg3.jpeg'
import bg4 from 'assets/pictures/background/bg4.jpeg'
import { ButtonMUI } from 'components/styled/Buttons'
import { push } from '@lagunovsky/redux-react-router'
import { URL_WANTED } from 'home/constants/HomeConstants'
import { template } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import i18n from 'simple-react-i18n'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import { USER_MODULES_LINKS } from '../../administration/components/user/constants/UserConstants'
import { NAME_LOGIN_PICTURE, RELOAD_SELECTED_SEARCH_VALUES } from '../../administration/constants/AdministrationConstants'
import { applicationName } from '../../conf/SieauConstants'
import { componentHasHabilitations } from '../../utils/HabilitationUtil'
import HomeAction from '../actions/HomeAction'
import { PASTEL_COLOR } from 'utils/constants/ColorTheme'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import InputLogin from 'components/forms/InputLogin'
import { contentsPath } from 'conf/basepath'
import { useMemo } from 'react'

const $ = window.$

const Login = () => {
    const dispatch = useDispatch()

    const backgroundPicture = useApplicationSetting(NAME_LOGIN_PICTURE)
    const nextPageUser = useApplicationSetting('PageApresConnexion')
    const logoSetting = useApplicationSetting('applicationLogoConnexion')
    const applicationTitle = useApplicationSetting('applicationTitle')
    const envRecette = useApplicationSetting('envRecette')
    const applicationNameSetting = useApplicationSetting('applicationName')

    const [login, setLogin] = useState('')
    const [defaultBackground, setDefaultBackground] = useState(false)
    const [password, setPassword] = useState('')
    const [logo, setLogo] = useState()

    useEffect(() => {
        if (backgroundPicture) {
            const backgroundUrl = `${contentsPath}_PUBLIC/${backgroundPicture}`
            dispatch(HomeAction.checkImageExists(backgroundUrl)).then((found) => {
                if (found) {
                    document.body.classList.add('login-body')
                    document.querySelector('.login-body').style.backgroundImage = `url('${backgroundUrl}')`
                } else {
                    setDefaultBackground(true)
                }
            })
        }
    }, [backgroundPicture])

    useEffect(() => {
        if (logoSetting) {
            dispatch(HomeAction.checkImageExists(logoSetting)).then(exists => {
                if (exists) {
                    setLogo(
                        (<img
                            src={ logoSetting }
                            alt='logo SIEau'
                            className='responsive-img'
                        />),
                    )
                }
            })
        }
    }, [logoSetting])

    useEffect(() => {
        return () => {
            if (document.querySelector('.login-body')) {
                document.querySelector('.login-body').style.backgroundImage = ''
            }
            document.body.classList.remove('login-body')
        }
    }, [])

    const onLogin = () => {
        dispatch(AdministrationAction.resetCache())
        dispatch(HomeAction.showWelcomePopup(true))
        dispatch({ type: RELOAD_SELECTED_SEARCH_VALUES })
        const remainingHabilitations = USER_MODULES_LINKS.filter(f => componentHasHabilitations(f.habilitation))
        if (remainingHabilitations.length === 1) {
            dispatch(push(remainingHabilitations[0].link))
        } else {
            const wantedUrl = localStorage.getItem(URL_WANTED)
            if (wantedUrl && wantedUrl !== '') {
                localStorage.removeItem(URL_WANTED)
                const strangeUrl = wantedUrl.startsWith('tp://') || wantedUrl.startsWith('tps://') ? '/' : wantedUrl
                const formatWanted = strangeUrl.startsWith('/') ? strangeUrl : `/${strangeUrl}`
                dispatch(push(formatWanted))
            } else if (nextPageUser && nextPageUser !== '' && nextPageUser.includes('/')) {
                const formatPageUser = nextPageUser.startsWith('/') ? nextPageUser : `/${nextPageUser}`
                dispatch(push(formatPageUser))
            } else if (nextPageUser && nextPageUser !== '' && nextPageUser.includes('/')) {
                const formatPage = nextPageUser.startsWith('/') ? nextPageUser : `/${nextPageUser}`
                dispatch(push(formatPage))
            } else {
                dispatch(push('/'))
            }
        }
    }

    useEffect(() => {
        if (defaultBackground) {
            $('.slider').slider({ indicators: false })
        }
    }, [defaultBackground])

    const onSubmit = () => {
        if (password && login) {
            dispatch(HomeAction.login(login, password, onLogin))
        }
    }

    const isRecetteEnv = () => {
        if (envRecette === '1') return true
        switch (process.env.REACT_APP_BRANCHE) {
            case 'develop': return true
            default: return false
        }
    }

    const getColor = () => {
        return isRecetteEnv() ? PASTEL_COLOR.orange : ''
    }

    const slider = useMemo(() => {
        return defaultBackground ? (
            <div className='slider fullscreen'>
                <ul className='slides'>
                    { [bg1, bg2, bg3, bg4].map(b => {
                        return (
                            <li key={b}>
                                <img src={ b } />
                            </li>
                        )
                    }) }
                </ul>
            </div>
        ) : null
    }, [defaultBackground])

    return (
        <Grid
            container
            justifyContent='center'
            alignItems='center'
            sx={{
                height: '100%',
            } }
        >
            { slider }
            <Grid size={2.5} sx={{ zIndex: 2 }}>
                <Card>
                    <CardContent>
                        <Stack spacing={1} alignItems='center' justifyContent='center' sx={{ padding: '10px 0' }}>
                            { logo || applicationTitle && <h4 style={{ textAlign: 'center' }}> { applicationTitle || '' } </h4> }
                            <Grid sx={{ width: '100%' }}>
                                <InputLogin
                                    label={i18n.login}
                                    iconLabel='person'
                                    value={login}
                                    onChange={setLogin}
                                    onEnterKeyPress={onSubmit}
                                    required
                                    data-cy='login'
                                />
                            </Grid>
                            <Grid sx={{ width: '100%' }}>
                                <InputLogin
                                    label={i18n.password}
                                    iconLabel='lock'
                                    passwordInput
                                    value={password}
                                    onChange={setPassword}
                                    onEnterKeyPress={onSubmit}
                                    required
                                    data-cy='password'
                                />
                            </Grid>
                            <ButtonMUI
                                id='submit_btn'
                                data-cy='submit'
                                variant='contained'
                                style={{ width: '100%' }}
                                onClick={onSubmit}
                            >
                                { i18n.toLogin }
                            </ButtonMUI>
                            <Link to='/reset'>{ i18n.forgetPassword }</Link>
                            <Stack
                                container
                                justifyContent='center'
                                alignItems='center'
                                sx={{ backgroundColor: `${getColor()}`, padding: '10px 0', width: '100%' }}
                            >
                                {template(i18n.signVersion)({ name: applicationNameSetting || applicationName, version: process.env.REACT_APP_VERSION }) }
                                <span>{ isRecetteEnv() ? (i18n.envRecette):(i18n.envProd) }</span>
                                <a href='http://www.aquasys.fr' target='_blank'><b>{ i18n.aquasysCopyright }</b></a>
                            </Stack>
                            <span id='aquasys_app_version' className={process.env.REACT_APP_VERSION}/>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

Login.propTypes = {
}


export default Login
